import React from "react";
import {Button, Modal} from "antd";

const SupplierCurrencyPopup = ({visible, onClose, onClickAction, supplierDetails, selectedCurrency}) => {

    const handlePopupCancel = () => {
        // Reset notes to initial value
        onClose();
    };

    const supplier = {
        name: supplierDetails?.name,
        currencyCount: supplierDetails?.companyAllowedCurrencies?.length ?? 0,
        currencyList: supplierDetails?.companyAllowedCurrencies?.filter(item => item && item !== undefined).map(item => item.value).join(", "),
        selectCurrrency: supplierDetails?.companyAllowedCurrencies?.find(item => item.id === selectedCurrency)?.value ?? selectedCurrency
    };

    return (
        <Modal
            title="Currency alert"
            open={visible}
            onCancel={handlePopupCancel}
            footer={null}
            width={750}
        >
            <div className="popup">
                <div className="popup-inner">
                    <p className="my-5"><strong><span
                        style={{textDecoration: "underline"}}>{supplierDetails?.name?.toUpperCase()}</span></strong> has <strong>{supplier?.currencyCount}</strong> available
                        currencies <strong>(<span
                            style={{color: "rgb(255, 165, 0)"}}>{supplier?.currencyList}</span>)</strong>. Please ensure
                        that the selected currency <strong>(<span
                            style={{color: "rgb(95, 198, 106)"}}>{supplier?.selectCurrrency}</span>)</strong> is
                        correct. </p>
                    <ul
                        className="flex">
                        <li>
                            <Button
                                className="text-[14px] flex items-center justify-center font-normal border cursor-pointer border-[#020A08] rounded-full text-[#020A08] hover:text-white hover:bg-[#020A08] w-[110px] bg-white h-8"
                                onClick={handlePopupCancel}>Cancel</Button>
                        </li>
                        <li>
                            <Button
                                type="primary"
                                className="text-[14px] flex items-center justify-center font-normal border cursor-pointer rounded-full ml-2 hover:opacity-[0.8]"
                                onClick={onClickAction}>Confirm and Submit</Button>
                        </li>
                    </ul>
                </div>
            </div>
        </Modal>
    );
};

export default SupplierCurrencyPopup;
